module.exports = __webpack_public_path__ + "images/category_lp/common/sticky_estimate_button/flat_gold@2x_ba8b95b6dc8b0ee2f65ed64dab507e89.png";